import { comMapping } from '@/components/util/Function/comMapping';

export function getdata() {
    var obj = {
        searchlist: [
            {
                prop: 'nameDesc',
                label: '名称',
                type: 'input'
            },
            {
                prop: 'shuizId',
                label: '税表名称',
                type: 'select',
                selectval: []
            },
            {
                prop: 'defaultFlag',
                label: '是否默认',
                type: 'select',
                selectval: comMapping.$flag
            },
            {
                prop: 'nsrmc',
                label: '应用公司',
                type: 'input'
            }
        ],
        searchdata: {
            nameDesc: '',
            shuizId: '',
            defaultFlag: '',
            nsrmc: ''
        },
        headData: [
            {
                title: '名称',
                prop: 'nameDesc',
                width: 110,
                custom: true

            },
            {
                title: '税表名称',
                prop: 'shuizId',
                width: 130,
                custom: true

            },
            {
                title: '是否默认',
                prop: 'defaultFlag',
                width: 50,
                custom: true

            },
            {
                title: '应用公司',
                prop: 'companyNames',
                width: 130,
                custom: true

            },
            {
                title: '操作',
                prop: 'cz',
                custom: true,
                fixed: 'right',
                width: 200
            }
        ],
        formlist: [
            {
                prop: 'nameDesc',
                label: '名称',
                type: 'input',
                width: '340px'
            },
            {
                prop: 'shuizId',
                label: '税表名称',
                type: 'select',
                width: '340px',
                selectval: []
            }
        ],
        formdata: {
            nameDesc: '',
            shuizId: '',
            defaultFlag: false
        },
        comHeadData: [
            {
                title: '公司代码',
                prop: 'companyCode',
                width: 110,
                custom: true
            },
            {
                title: '公司名称',
                prop: 'nsrmc',
                width: 130,
                custom: true
            }
        ],
        pagination: {
            pageNum: 1,
            pageSize: 50,
            total: 0,
            paginationkey: 0
        }
    };
    return obj;
}
